"use client";

import { poppins_body_md_semibold } from "@frontend/design-system";
import styled, { css } from "styled-components";

export const TabMenuWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  gap: var(--Spacing-8, 0.8rem);
`;

export const TabMenuButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--Spacing-4, 0.4rem);
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${poppins_body_md_semibold};
  padding: 0.8rem 1.2rem;
  border-radius: 0.4rem;
  cursor: pointer;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16),
    0px 0px 1px 0px rgba(0, 0, 0, 0.12);
  background: var(--Color-Common-Bg-Primary, #fff);
  height: 4rem;

  &:hover {
    color: var(--Color-Common-Text-Interactive-Primary-Hovered, #017abc);
    background: var(--Color-Common-Bg-Interactive-Secondary-Hovered, #f0f2f4);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
      0px 0px 2px 0px rgba(0, 0, 0, 0.12);

    path {
      fill: var(--Color-Common-Text-Interactive-Primary-Hovered, #017abc);
    }
  }
  &:active {
    color: var(--Color-Common-Text-Interactive-Primary-Pressed, #015d8e);
    background: var(--Color-Common-Bg-Interactive-Secondary-Pressed, #e5e7eb);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16),
      0px 0px 1px 0px rgba(0, 0, 0, 0.12);

    path {
      fill: var(--Color-Common-Text-Interactive-Primary-Pressed, #015d8e);
    }
  }

  &:disabled {
    color: var(--Color-Common-Text-Disabled, #96a1b0);
    background: transparent;
    box-shadow: none;
    cursor: not-allowed;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.16),
      0px 0px 1px 0px rgba(0, 0, 0, 0.12);

    path {
      fill: var(--Color-Common-Text-Disabled, #96a1b0);
    }
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: var(--Color-Common-Text-Interactive-Primary, #0198e9);
      background: var(--Color-Common-Bg-Interactive-Primary-Subtle, #f0f9ff);

      path {
        fill: var(--Color-Common-Text-Interactive-Primary, #0198e9);
      }
    `}

  flex-shrink: 0;
  min-width: fit-content;
`;
